import React from 'react';
import { DEFAULT_ESCROW_PAGE } from 'spa/constants/HeaderConstants';
import HeaderV3 from 'spa/containers/HeaderV3';
import TwoFactorAuthenticationContainer from 'spa/containers/TwoFactorAuthentication';

const TwoFactorAuthenticationPage = () => (
  <React.Fragment>
    <HeaderV3 title="" pageType={DEFAULT_ESCROW_PAGE} />
    <div>
      <div className="twoFactorAuth section section--small section--dark">
        <div className="twoFactorAuth-content section-container">
          <div className="twoFactorAuth-inner">
            <TwoFactorAuthenticationContainer />
          </div>
        </div>
      </div>
    </div>
  </React.Fragment>
);

export default TwoFactorAuthenticationPage;
